import { FC } from 'react';
import s from './info.module.scss';
import { ArtistView, StoreItemView, Toy } from '@specs/views';
import { collectionMeta, drop, storeItem } from '@specs/specs';
import { useTranslation } from '@hooks/useTranslation';
import { Stats } from '@components/Pages/ToyPage/Info/Stats/Stats';
import { Buttons } from '@components/Pages/ToyPage/Info/Buttons/Buttons';
import cn from 'classnames';
interface Props extends Toy.Single {
  artist: ArtistView | null | undefined;
  collection: collectionMeta | null | undefined;
  haveFigurinesForSale: boolean;
  firstStoreItem: StoreItemView | undefined;
  myFirstStoreItem: storeItem | undefined;
  currentDrop: drop | undefined;
  isCollectable: boolean;
  isLoading: boolean;
  isArtClub: boolean;
  isArtClubMember: boolean;
  isBonusToy: boolean;
  isHaveToyInCollection: boolean;
  iAmTheCreator: boolean;
}
export const Info: FC<Props> = ({
  currentDrop,
  firstStoreItem,
  myFirstStoreItem,
  isCollectable,
  isArtClubMember,
  haveFigurinesForSale,
  isArtClub,
  isLoading,
  name,
  artist,
  collection,
  imageid,
  slug,
  publication,
  id: toyId,
  isBonusToy,
  isHaveToyInCollection,
  iAmTheCreator
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.info} data-sentry-component="Info" data-sentry-source-file="Info.tsx">
            <div className={s.info__head}>
                <div className={cn(s.info__name, '_ellipsis')}>
                    {name}
                </div>
                {isLoading ? <div className={s.info__artist}>
                        {tr({
          id: 'btn.loading'
        })}
                    </div> : artist && <div className={s.info__artist}>
                            {tr({
          id: 'toy.page.artist.by'
        }, {
          artistName: artist.profile?.shortid || ''
        })}
                        </div>}
                {isLoading ? <div className={s.info__collection}>
                        {tr({
          id: 'btn.loading'
        })}
                    </div> : collection && <div className={s.info__collection}>
                            {tr({
          id: 'toy.page.part.of.collection'
        }, {
          collectionName: collection.name
        })}
                        </div>}
            </div>
            <div className={s.info__stats}>
                <Stats toyId={toyId} data-sentry-element="Stats" data-sentry-source-file="Info.tsx" />
            </div>
            <Buttons slug={slug} haveFigurinesForSale={haveFigurinesForSale} isArtClubMember={isArtClubMember} isArtClub={isArtClub} myFirstStoreItem={myFirstStoreItem} firstStoreItem={firstStoreItem} isLoading={isLoading} currentDrop={currentDrop} isCollectable={isCollectable} toyId={toyId} toyName={name} imageid={imageid} isBonusToy={isBonusToy} collectionId={collection?.id} isHaveToyInCollection={isHaveToyInCollection} iAmTheCreator={iAmTheCreator} publication={publication} data-sentry-element="Buttons" data-sentry-source-file="Info.tsx" />
        </div>;
};